import { type FC } from 'react';

import { multiplication } from '@/common/lib/decimal';
import { type GoodsType } from '@/common/types/goods';
import { selectGoodsRecipeByGoodsName } from '@/redux/selectors/workshopSelectors';
import { useAppSelector } from '@/redux/store';

import { ProductionRecipeItem } from '../ProductionRecipeItem/ProductionRecipeItem';

interface ProductionRecipeProps {
  goodsName?: GoodsType;
  toAdd?: number;
  workshopId?: string;
  withStock?: boolean;
}

const ProductionRecipe: FC<ProductionRecipeProps> = ({
  goodsName,
  toAdd,
  workshopId,
  withStock,
}) => {
  const recipeList = useAppSelector((state) =>
    selectGoodsRecipeByGoodsName(state, workshopId, goodsName),
  );

  return (
    <div className="w-full flex items-center justify-center gap-4">
      {recipeList?.map((props) => {
        const quantity = toAdd
          ? multiplication(props.quantity, toAdd)
          : props.quantity;

        return (
          <ProductionRecipeItem
            key={props.name}
            name={props.name}
            quantity={quantity}
            withStock={withStock}
          />
        );
      })}
    </div>
  );
};

export { ProductionRecipe };
